<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  > 
  <v-container>
    <v-subheader class="pa-0 ma-0">
      <v-breadcrumbs :key="breadcrumbKey" :items="itemsBreadcrumb">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template v-slot:item="props">
        <a :href="props.item.href" :class="[props.item.class]">{{ props.item.text }}</a>
      </template>
    </v-breadcrumbs>
    </v-subheader>
    <v-container class="ml-4 mt-8 form-container">
      <p class="ml-4 data-user">{{$t('dataUser')}}</p>
    <v-row>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('username')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        <v-text-field
          v-model="user.username"
          :counter="15"
          :rules="[
              v => !!v ||  $t('rules.required',{field:$t('username')}),
              v => (v && v.length <= 15) ||  $t('rules.maxLength',{field:$t('username'), number:15}),
              v => (v && v.length >4 ) ||  $t('rules.minLength',{field:$t('username'), number:4}),
              v => (v && v.split(' ').length <= 1 ) ||  $t('rules.whiteSpaces',{field:$t('username'), number:4}),
            ]"
            :label="$t('username')+'*'"
            
            required
            :disabled="userInfoLoaded != null"
            outlined
            dense
            class="input"
        ></v-text-field>
      </v-col>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('role')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
          <v-select
            v-model="role"
            :items="roles"
            item-text="type"
            item-value="value"
            :rules="[
                v => !!v ||  $t('rules.required',{field:$t('role')})
              ]"
            :label="$t('role')+'*'"
            required
            :disabled="disableRole"
            outlined
            dense
            class="input"
          ></v-select>
        </v-col>
      </v-row>
      <p class="ml-4 data-user">{{$t('personalData')}}</p>
    <v-row>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('firstname')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        <v-text-field
          v-model="user.firstname"
          :counter="15"
          :rules="[
              v => !!v ||  $t('rules.required',{field:$t('firstname')}),
              v => (v && v.length <= 15) ||  $t('rules.maxLength',{field:$t('firstname'), number:15}),
              v => (v && v.length >4 ) ||  $t('rules.minLength',{field:$t('firstname'), number:4}),
            ]"
            :label="$t('firstname')+'*'"
          required
            outlined
            dense
            class="input"
        ></v-text-field>
      </v-col>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('lastname')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        <v-text-field
          v-model="user.lastname"
          :counter="15"
          :rules="[
              v => !!v ||  $t('rules.required',{field:$t('lastname')}),
              v => (v && v.length <= 15) ||  $t('rules.maxLength',{field:$t('lastname'), number:15}),
              v => (v && v.length >4 ) ||  $t('rules.minLength',{field:$t('lastname'), number:4}),
            ]"
            :label="$t('lastname')+'*'"
          required
            outlined
            dense
            class="input"
        ></v-text-field>
      </v-col>
    </v-row>
      <p class="ml-4 data-user">{{$t('contactData')}}</p>
    <v-row>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('email')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        <v-text-field
          v-model="user.email"
          :rules="[
              v => !!v ||  $t('rules.required',{field:$t('email')}),
              v => /.+@.+\..+/.test(v) || $t('rules.email'),
            ]"
            :label="$t('email')+'*'"
          required
            outlined
            dense
            class="input"
        ></v-text-field>
      </v-col>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('phone')}}</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        <v-text-field
          v-model="user.phone"
          :label="$t('phone')"
            outlined
            dense
            class="input"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('office')}}</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        <v-text-field
          v-model="user.organization"
          :label="$t('office')"
            outlined
            dense
            class="input"
          ></v-text-field>
      </v-col>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label">
          <p>{{$t('additionalInfo')}}</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        <v-text-field
          v-model="user.additionalInfo"
          :label="$t('additionalInfo')"
            outlined
            dense
            class="input"
        ></v-text-field>
      </v-col>
    </v-row>
      <p class="ml-4 data-user">{{$t('dataOrganism')}}</p>
      <v-row>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
          <p>{{$t('organisms')}}*</p>
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
          <v-select
            v-model="user.organism"
            :items="organism"
            item-text="type"
            item-value="value"
            :label="$t('organisms')+'*'"
            required
            outlined
            dense
            class="input"
            :rules="[
                (v) => v.length>0 ||  $t('rules.required',{field:$t('organism')}),
              ]"
          ></v-select>
        </v-col>
        <v-col cols="4" md="2" lg="1" align-self="center" class="ml-7 mb-2 label field-resize">
        </v-col>
        <v-col cols="7" md="3" lg="4" class="field-resize">
        </v-col>
      </v-row>
    </v-container>
    <div class="text-right mr-8 buttons">
      <p class="mr-4 required-field">{{$t('requiredFieldsDescription')}}</p>
    <v-btn
        color="#91919c"
        class="mr-3 btn-cancel"
        @click="cancel"
        text
      >
        {{$t('cancelButton')}}
      </v-btn>
      <v-btn
        :disabled="!valid || (loadedUser!==undefined && !edited)"
        color="#5f98ed"
        class="mr-3 white--text btn-confirm"
        @click="saveUser"
        rounded
      >
      {{$t('acceptButton')}}
    </v-btn>
    </div>
  </v-container>
  </v-form>
</template>

<script>

export default {
  data(){
    return {
      valid: false,
      roles: [],
      show: false,
      //confirmPassword: '',
      role: '',
      organism: [],
      edited:false,
      loadedUser:undefined,
      user: {
        username: '',
        //password: '',
        roles: undefined,
        firstname: '',
        lastname: '',
        organization: '',
        additionalInfo: '',
        phone: '',
        email: '',
        organism: []
      },
      nameRules: [
        v => !!v || 'Field required',
        v => (v && v.length <= 15) || 'Name must be less than 15 characters',
        v => (v && v.length >5 ) || 'Name  must be superior than 5 characters',
      ], 
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      checkbox: false,
      breadcrumbText: 'newUser',
      breadcrumbKey: 0,
      ready: false
    }
  },
  mounted(){
    this.retrieveRoles()
    this.getOrganisms();
    let userPreloaded= this.$store.getters.getUserForEdition
    this.loadedUser = {...userPreloaded}
    if(userPreloaded){
      this.breadcrumbText = 'updateUser'
      this.user = userPreloaded
      this.role = userPreloaded.role
      this.breadcrumbKey++
    }
  },
  beforeDestroy(){
    this.$store.commit('setUserForEdition', null)
  },
  computed: {
    userInfoLoaded: {
      get(){
        return (this.$store.getters.getUserForEdition)
      }
    },
    disableRole() {
      return (this.userInfoLoaded && this.$store.getters.getUserForEdition.username === this.$store.getters.getUsername)
    },
    itemsBreadcrumb() {
      return [
        {
          text: this.$t('users'),
          href: '/users',
          disabled: false,
          class: "gray"
        },
        {
          text: this.$t(this.breadcrumbText),
          disabled: true,
          class: "blue"
        }
      ]
    }
  },
  watch:{
    role(newValue){
      if(newValue !== this.loadedUser.role){
        this.edited=true
      } else{
        this.edited = false
      }
    },
    user:{
      handler:function(newValue){
        let fields = Object.keys(newValue)
        this.edited = false
        var i= 0;
        while(!this.edited && i < fields.length) {
          if(this.loadedUser[ fields[i] ] !== newValue[ fields[i] ]){
            this.edited = true  
          } else{
            this.edited = false
            i ++
          }
        }
      },
      deep:true
    }
  },
  methods: {
    getOrganisms(){
      this.$extractions.getAllOrganisms().then(response=>{
        var organisms = []
        response.data.forEach(organism => {
          organisms.push(organism.name)
        })
        this.organism = organisms
      }).catch(e=>{
        console.log('Error: ', e)
      })      
    },
    retrieveRoles(){
      this.$extractions.getRoles().then(response=>{
        var roles_db= []
        response.data.forEach(role=>{
          roles_db.push({value:role,type:this.$t('roleType.' + role)})
        })
        this.roles=roles_db
      }).catch(e=>{
        console.log('getRoles error:', e)
      })
    },
    saveUser() {
      if(this.$refs.form.validate()){
        this.user.roles = [this.role]
        if(!this.userInfoLoaded)          
          this.$extractions.postUser(this.user).then(()=>{
            this.$store.dispatch('snackAlert', true)
            this.$router.push('/users')
          }).catch(error=>{
            console.log('error', error)
            if(error.toString().includes('409')){
              this.$store.commit('setSnackText', 'nameTaken')
              this.$store.commit('setSnackParameter', {name: this.user.username})
              this.$store.commit('setSnackBar', true)
            }
            else{
              this.$store.dispatch('snackUserAlert', false)
            }
          })
        else{
          this.$extractions.updateUser(this.user).then(()=>{
            this.$store.dispatch('snackAlert', true)
            this.$router.push('/users')
          }).catch(error=>{
            console.log('error', error)
            this.$store.dispatch('snackAlert', false)
            this.$router.push('/users')
          })
        }
      }
    },
    cancel() {
      this.$router.push('/users')
    }
  },
}

</script>
<style>
  
  .form-container{
    border: 1px solid #eee;
    width: 97%;
    border-radius: 18px;
    font-family: 'Open Sans', 'sans-serif';
  }
  .data-user{
    color: #91919c;
    font-size: 14px;
    font-weight: 500;
  }
  .input{
    border-radius: 13px!important;
  }
  .v-label{
    font-size: 13px!important;
    font-weight: 500;
    color: #91919c!important;
  }
  .label{
    font-size: 13px!important;
    font-weight: bold;
  }
  .btn-confirm:hover{
    background-color: #5f98ed!important;
  }
  .btn-cancel{
    color: #91919c!important;
  }
  .btn-cancel:hover{
    color: #65656d!important;
  }
  .btn-cancel::before{
    background-color: transparent!important;
  }
  .btn-confirm{
    background-color: #5f98ed!important;
  }
  .required-field{
    font-size: 12px;
  }
  .gray{
    color: #888!important;
    text-decoration: none;
  }
  .v-application .blue{
    color: #5f98ed!important;
    background-color: transparent!important;
    cursor:default!important;
  }
  @media (max-width: 500px) {
    .input{
      font-size: 13px!important;
    }
  }
  @media (max-width: 397px) {
    .field-resize{
      flex: 0 0 auto!important;
      max-width: 100%!important;
    }
  }
  @media (max-width: 330px) {
    .v-application .text-right{
      margin-right: 0px!important;
    }
  }
</style>